import { Box, Grid } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { GenerateOtpDTO, postGenerateOtp, getCandidateDetailsForGDPR } from 'wisestep-api';
import {
  ControlledTextInput,
  Label,
  WsButton,
  WsColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { AppLayoutTheme } from '../../../features/candidates/utils/CandidateHelper';
import { failed, success, info } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import useGDPRSettings from '../hooks/useGDPRSettings';

import { GdprSettingsParam } from './DataProtectionLayout';

const DataProtection = () => {
  const params = useParams<GdprSettingsParam>();
  const methods = useForm();
  const { handleSubmit } = methods;
  const [settings] = useGDPRSettings(params.companyId ?? '');
  const companyName = settings?.companyNameAndLogoUrls?.keys?.length
    ? settings?.companyNameAndLogoUrls?.keys[0]
    : '';
  const setNotification = useNotificationStore((state) => state.setNotification);
  const onValidation = async (data) => {
    try {
      let interactionResponse;
      try {
        interactionResponse = await getCandidateDetailsForGDPR(
          data.email,
          settings?.workspaceIdsToUseForCandidateInfoSearch?.[0] ?? ''
        );
      } catch (e) {
        console.log('candidate data not found');
        setNotification(info('No Candidate Data found for the Email'));
        return;
      }
      if (interactionResponse?.data?.id) {
        const request: GenerateOtpDTO = {
          companyCandidateGdprSettingsId: settings?.id ?? '',
          email: data.email,
          requestOriginHostName: companyName,
        };
        await postGenerateOtp(request);
        setNotification(success('OTP generated successfully!'));
      } else {
        setNotification(info('No Candidate Data found for the Email'));
      }
    } catch (e) {
      console.log(e);
      setNotification(failed('OTP could not be generated!'));
    }
  };

  return (
    <FormProvider {...methods}>
      <Box component="form" onSubmit={handleSubmit(onValidation)} mx={4} my={2}>
        <AppLayoutTheme p={3}>
          <Label sx={{ fontSize: '28px', fontWeight: 'bold', color: WsColors.White }}>
            {settings?.companyName}
          </Label>
        </AppLayoutTheme>
        <Grid item xs={12} my={2} bgcolor={WsColors.White} py={2}>
          <Grid mt={1} item xs={12} justifyContent="center" display="flex">
            <Label sx={{ fontSize: '20px', fontWeight: 'bold' }}>
              Data Protection And Privacy Settings Page
            </Label>
          </Grid>
          <Grid mt={3} item xs={12} justifyContent="center" display="flex">
            <Box>
              <WsTypography variant={WsTypoVariants.TITLE} bold>
                Email Address
              </WsTypography>
              <ControlledTextInput
                sx={{ width: '400px', mt: 2 }}
                name={'email'}
                placeholder="Enter Email ID to get Access Link"
                variant="outlined"
                required
                autoComplete="workspaceName"
              />
            </Box>
          </Grid>
          <Grid mt={4} item xs={12} justifyContent="center" display="flex">
            <WsButton variant="contained" type="submit">
              Get Access Link
            </WsButton>
          </Grid>
        </Grid>
      </Box>
    </FormProvider>
  );
};
export default DataProtection;
